import Role from '@/auth/signin/model/Role';
import { PlatformType } from '@/main/model/PlatformType';

export type Token = {
  token: string;
  expiresAt: string;
};

export type LoginForm = {
  id: string;
  password: string;
};

export type ResetPasswordForm = {
  password: string;
  passwordCheck: string;
};

export const Permission = {
  Create: 'create',
  Read: 'read',
  Update: 'update',
  Delete: 'delete',
} as const;
// eslint-disable-next-line
export type Permission = (typeof Permission)[keyof typeof Permission];

const SupportLanguage = {
  KOREAN: 'ko',
  ENGLISH: 'en',
} as const;
// eslint-disable-next-line
export type SupportLanguage = (typeof SupportLanguage)[keyof typeof SupportLanguage];

type Department = {
  id: string;
  name: string;
};

export enum OnboardingStatus {
  IntegrationRequired = 'integration_required', // 카페24, 아임웹 등 외부 서비스 연동 필요
  MigrationInProgress = 'migration_in_progress', // 데이터 마이그레이션 진행 중
  MigrationCompleted = 'migration_completed', // 데이터 마이그레이션 완료
  SenderInfoRequired = 'sender_info_required', // 문자, 카카오 정보 입력
  OnboardingComplete = 'onboarding_complete', // 온보딩 완료
}

export type Subscription = {
  id: number;
  name: string;
  end_date: string; // ex) '2024-08-26'
};
export type Profile = {
  id: number;
  name: string;
  brandName?: string;
  loginId: string;
  photoUri?: string;
  role: Role;
  department: Department;
  language: SupportLanguage;
  testPhone: string;
  onboarding_status: OnboardingStatus;
  mall_id: string | null;
  platform_type: PlatformType;
  subscription: Subscription | null;
};

export type UpdatableProfile = Pick<Profile, 'name' | 'language' | 'testPhone'>;
export type PartOfUpdatableProfile = Partial<UpdatableProfile>;
